import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "contact-page-wrapper" }
const _hoisted_2 = { class: "contact-page-inner" }
const _hoisted_3 = { class: "alert-icon" }
const _hoisted_4 = { class: "contact-grid-row" }
const _hoisted_5 = {
  key: 0,
  class: "contact-info-col contact-sidebar"
}
const _hoisted_6 = {
  key: 0,
  class: "contact-sidebar__block"
}
const _hoisted_7 = { class: "contact-sidebar__title" }
const _hoisted_8 = {
  key: 0,
  class: "contact-sidebar__list"
}
const _hoisted_9 = {
  key: 1,
  class: "contact-sidebar__block margin-top"
}
const _hoisted_10 = { class: "contact-sidebar__title" }
const _hoisted_11 = {
  key: 0,
  class: "contact-sidebar__list"
}
const _hoisted_12 = { class: "contact-form-col" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = { class: "form-group turnstile-wrapper" }
const _hoisted_19 = ["data-sitekey"]
const _hoisted_20 = { class: "contact-form-footer" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_PageHeader = _resolveComponent("PageHeader")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageHeader, {
      title: (_ctx.contactData && _ctx.contactData.page_title),
      subtitle: (_ctx.contactData && _ctx.contactData.page_subtitle) || ''
    }, null, 8 /* PROPS */, ["title", "subtitle"]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.formStatus.message)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(['contact-form-alert', _ctx.formStatus.isSuccess ? '--success' : '--danger'])
          }, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.formStatus.isSuccess ? '✓' : '⚠'), 1 /* TEXT */),
            _createTextVNode(" " + _toDisplayString(_ctx.formStatus.message), 1 /* TEXT */)
          ], 2 /* CLASS */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.contactData.contact_header || _ctx.contactData.contact_header_two)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_ctx.contactData.contact_header)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.contactData.contact_header), 1 /* TEXT */),
                    (_ctx.parsedListOne.length)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parsedListOne, (item, index) => {
                            return (_openBlock(), _createElementBlock("li", { key: index }, [
                              _cache[6] || (_cache[6] = _createElementVNode("span", { class: "bullet" }, "→", -1 /* CACHED */)),
                              _createTextVNode(" " + _toDisplayString(item), 1 /* TEXT */)
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                      : _createCommentVNode("v-if", true)
                  ]))
                : _createCommentVNode("v-if", true),
              (_ctx.contactData.contact_header_two)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("h3", _hoisted_10, _toDisplayString(_ctx.contactData.contact_header_two), 1 /* TEXT */),
                    (_ctx.parsedListTwo.length)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_11, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.parsedListTwo, (item, index) => {
                            return (_openBlock(), _createElementBlock("li", { key: index }, [
                              _cache[7] || (_cache[7] = _createElementVNode("span", { class: "bullet" }, "→", -1 /* CACHED */)),
                              _createTextVNode(" " + _toDisplayString(item), 1 /* TEXT */)
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                      : _createCommentVNode("v-if", true)
                  ]))
                : _createCommentVNode("v-if", true)
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_12, [
          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "contact-form-header" }, [
            _createElementVNode("h2", { class: "contact-form-title" }, "Submit A Question"),
            _createElementVNode("p", { class: "contact-form-subtext" }, "Please send us a ticket by filling out the validation fields below.")
          ], -1 /* CACHED */)),
          _createElementVNode("form", {
            onSubmit: _cache[5] || (_cache[5] = _withModifiers((...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"])),
            class: "contact-tech-form"
          }, [
            _createElementVNode("div", _hoisted_13, [
              _cache[8] || (_cache[8] = _createElementVNode("label", { class: "form-label" }, "Full Name *", -1 /* CACHED */)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.formFields.full_name) = $event)),
                placeholder: "e.g. John Doe",
                required: "",
                class: "form-input"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, _ctx.formFields.full_name]
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _cache[9] || (_cache[9] = _createElementVNode("label", { class: "form-label" }, "Email Address *", -1 /* CACHED */)),
              _withDirectives(_createElementVNode("input", {
                type: "email",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.formFields.email) = $event)),
                placeholder: "name@company.com",
                required: "",
                class: "form-input"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, _ctx.formFields.email]
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _cache[10] || (_cache[10] = _createElementVNode("label", { class: "form-label" }, "Phone Number *", -1 /* CACHED */)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.formFields.phone_number) = $event)),
                placeholder: "07771122333",
                required: "",
                class: "form-input"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, _ctx.formFields.phone_number]
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _cache[11] || (_cache[11] = _createElementVNode("label", { class: "form-label" }, "Subject *", -1 /* CACHED */)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.formFields.subject) = $event)),
                placeholder: "Project Scope or Network Inquiry",
                required: "",
                class: "form-input"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, _ctx.formFields.subject]
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _cache[12] || (_cache[12] = _createElementVNode("label", { class: "form-label" }, "Message Details *", -1 /* CACHED */)),
              _withDirectives(_createElementVNode("textarea", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.formFields.message) = $event)),
                rows: "5",
                placeholder: "Describe your architectural requirements...",
                required: "",
                class: "form-textarea"
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, _ctx.formFields.message]
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", {
                ref: "turnstileRef",
                id: "captcha-container",
                class: "cf-turnstile",
                "data-sitekey": _ctx.turnstileSiteKey
              }, null, 8 /* PROPS */, _hoisted_19)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("button", {
                type: "submit",
                class: "contact-submit-btn",
                disabled: _ctx.isSubmitting
              }, [
                (!_ctx.isSubmitting)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Submit Ticket"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_23, "Processing Request..."))
              ], 8 /* PROPS */, _hoisted_21)
            ])
          ], 32 /* NEED_HYDRATION */)
        ])
      ])
    ])
  ]))
}